import statorama from '@compilorama/statorama';
import ENV from '@environment';

const _public = {};

_public.init = () => {
  const { ENABLED, SRC, ID } = ENV.ANALYTICS;
  statorama.init({ enabled: ENABLED, src: SRC, id: ID });
};

_public.track = (eventTitle, eventData) => {
  statorama.track(eventTitle, eventData);
};

export default _public;
